import { FC, ReactElement, useState } from 'react'

import MessageBox from '../../../components/molecules/MessageBox'
import NotificationContext from './NotificationContext'
import { INotification } from './types'

const NotificationProvider: FC<{ children: ReactElement }> = ({ children }) => {
  const defaultNotification: INotification = {
    open: false,
    title: undefined,
    message: undefined,
    variant: undefined,
    autoHide: true
  }
  const [notification, setNotification] = useState<INotification>(defaultNotification)

  return (
    <NotificationContext.Provider value={{ notification, setNotification }}>
      {children}
      <MessageBox
        {...notification}
        onClose={() => {
          notification?.onClose?.()
          setNotification(defaultNotification)
        }}
      />
    </NotificationContext.Provider>
  )
}
export default NotificationProvider
